module.exports = __webpack_public_path__ + "img/icon_tips@3x.e5ee33bb.png";